module.exports = __webpack_public_path__ + "media/markers/marker-transparent-gray-blue-d1fdcde7.svg";